import { createFeatureSelector, createSelector } from '@ngrx/store'
import {
  EVENT_TICKET_PURCHASES_FEATURE_KEY,
  EventTicketPurchasesState,
  eventTicketPurchasesAdapter,
  initialEventTicketPurchasesState,
} from './event-ticket-purchases.reducer'

const selectEventTicketPurchasesStateBase = createFeatureSelector<EventTicketPurchasesState>(
  EVENT_TICKET_PURCHASES_FEATURE_KEY,
)

export const selectEventTicketPurchasesState = createSelector(
  selectEventTicketPurchasesStateBase,
  (state) => state ?? initialEventTicketPurchasesState,
)

const { selectAll, selectEntities } = eventTicketPurchasesAdapter.getSelectors()

export const selectEventTicketPurchasesLoaded = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.loaded,
)

export const selectAllEventTicketPurchases = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => selectAll(state),
)

export const selectEventTicketPurchasesEntities = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => selectEntities(state),
)

export const selectSelectedId = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.selectedId,
)

export const selectEntity = createSelector(
  selectEventTicketPurchasesEntities,
  selectSelectedId,
  (entities, selectedId) => (selectedId ? entities[selectedId] : undefined),
)

/**
 * Get event tickets for the selected purchase ID
 */
export const selectedPurchaseEventTickets = createSelector(
  selectEntity,
  (eventTicketPurchase) => eventTicketPurchase?.tickets || [],
)

/**
 * Get event ticket custom fields for the selected purchase ID
 */
export const selectedPurchaseCustomQuestions = createSelector(selectedPurchaseEventTickets, (eventTickets) =>
  eventTickets.length ? eventTickets[0].ticket_package.custom_questions : [],
)

export const selectSearchHistory = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.searchHistory,
)

export const selectDataView = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.dataView,
)

export const selectSearchTerm = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.searchTerm,
)

export const selectOrder = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.order,
)

export const selectRefunded = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.refunded,
)

export const selectDisplayColumns = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.displayColumns,
)

export const selectCount = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state?.count,
)

export const selectPlacePurchaseLoaded = createSelector(
  selectEventTicketPurchasesState,
  (state: EventTicketPurchasesState) => state.placePurchaseLoaded,
)

export const selectEventTicketPurchaseProfile = createSelector(
  selectEntity,
  (eventTicketPurchase) => eventTicketPurchase?.profile,
)

export const selectEventTicketPurchaseProfileRegistrationCustomQuestionAnswers = createSelector(
  selectEventTicketPurchaseProfile,
  (profile) => profile?.registration_custom_question_answers || [],
)
